module.exports = __webpack_public_path__ + "img/PL08170.d8c8926d.png";